import angular from 'angular';
import uiRouter from 'angular-ui-router';
import toCentsDirective from './toCents.directive';

import OrderAndDeliveryDetailsComponent from './orderAndDelivery.component';

const OrderAndDeliveryDetailsModule = angular.module('tinaba.components.services.orderAndDelivery', [
  uiRouter
])
  .config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.orderAndDelivery', {
      url: '/orderAndDelivery',
      template: '<order-and-delivery-details></order-and-delivery-details>'
    });
  })

  .component('orderAndDeliveryDetails', OrderAndDeliveryDetailsComponent)

  //.directive('toMillis', toMillisDirective)
  .directive('toCents', toCentsDirective)
;

export default OrderAndDeliveryDetailsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndDelivery/orderAndDelivery.js
 **/